import { render, staticRenderFns } from "./LeadComments.vue?vue&type=template&id=60eb0d14"
import script from "./LeadComments.vue?vue&type=script&lang=js"
export * from "./LeadComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports